import * as turf from '@turf/turf';

/**
 * Calculate polygon area (km²) from Turf coordinates
 * @param turfCoords Array of [lng, lat]
 */
export function calculateArea(turfCoords: number[][]): string {
  // Ensure polygon is closed
  const first = turfCoords[0];
  const last = turfCoords[turfCoords.length - 1];

  const closedCoords =
    first[0] === last[0] && first[1] === last[1]
      ? turfCoords
      : [...turfCoords, [...first]];

  const turfPolygon = turf.polygon([closedCoords]);
  const areaSqM = turf.area(turfPolygon);

  return (areaSqM / 1e6).toFixed(2); // km²
}
